<template>
  <div>

  </div>
</template>

<script>
export default {
  name: 'BackDashboard',
  data () {
    return {}
  },
  methods: {
    goPathClick (path) {
      this.$router.push(path)
    }
  }
}
</script>

<style scoped>
.div-card{
  width: 400px;
  margin: 20px 20px;
  color: white;
  font-size: 25px;
  text-align: center;
  padding: 50px 0;
  letter-spacing: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/pages/back/BackDashboard.vue